/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![GroupArrowDownIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB20lEQVR4nOVVO0skQRAe1MzkDFREuOQMxNxHthgIwm49RuipWp+RiiDoP9jQxNSfooLRwZ1ioKKoGJkqvhEVTXSl25l1HHXd9Sa7gqGnq6e+r+qrmhnP++8M/KAHWNaR9Q5J1uw+NXDfH2oBlitkLb5ecm39qREg6fFbAi0Cy5SXluVy5ieSHKZCwJzvAtZVZLm1q907Ej/oRNanEPzqWxI5OVguE3pfRmBIsuLIUbu/lT1RfjKpdZjxhJeGWaCPCJB13FWAikByBCyLRDJojKlNW6Lficq2mOVXVSS2qUj6F0hv7GqbW6qQ5OR9dTLvpWU5khEkuUfWB2CZJhr7UXFwJpOpQz8YQpJlIL1wEpCcI+mS9Ud6I5qOqqcoN5BvR5adTxpcjPQGMG3xODeyJH++Bic9LQeOrySL8djIX14W0u0KwB+AdLavb7i+KgLEYLSizElnP4z/koBkuRKCbHawIXx+DUk3fX+4KUlgffbM9iWWgZyFs7xQjoDCcbQAzke6229MY3Tu7kl3wz5txCu4B5LHbNa0lq9CZkpZsuxFJLFzN4HAug+gzSUCIJ2zr3+hUKh5/4nQN01GDHpjUsTAowlLgP+LxSV5qUYOUvuFRmazdT2xjU1k/gw8r6u08lxvRQAAAABJRU5ErkJggg==)
 */
export const GroupArrowDownIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M14.5 8a3 3 0 1 0-2.7-4.3c-.2.4.06.86.44 1.12a5 5 0 0 1 2.14 3.08c.01.06.06.1.12.1ZM20 15a1 1 0 1 0-2 0v5.59l-1.08-1.08-1.21-1.22a1 1 0 0 0-1.42 1.42l1.85 1.84 2.15 2.16a1 1 0 0 0 1.42 0l4-4a1 1 0 0 0-1.42-1.42L20 20.6V15ZM19 12c.4 0 .94-.68.65-.95a7.47 7.47 0 0 0-4.15-1.98c-.55-.08-.99.38-1.1.92-.06.3-.15.6-.26.87-.23.58-.05 1.3.47 1.63.39.25.75.52 1.1.82.26.23.7.15.9-.14A3 3 0 0 1 19 12Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M14.29 16.09c.44-.11.74-.67.42-.99A7.5 7.5 0 0 0 2 20.5c-.01.83.66 1.5 1.49 1.5a.2.2 0 0 0 .2-.16c.2-.96.56-1.87.88-2.54.1-.23.42-.15.42.1v2.1c0 .28.22.5.5.5h8c.1 0 .13-.13.06-.2l-.68-.68a3 3 0 0 1 1.4-5.03ZM9.5 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
